import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_STUDENT_BY_STATUS_REPORT } from "../Schema/Report";

const useGetStudentByStatusReport = ({ status }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_STUDENT_BY_STATUS_REPORT, {
    variables: {
      status: status,
    },
    onCompleted: ({ getStudentByStatusReport }) => {
      setTableData(getStudentByStatusReport || []);
      setLoading(false);
    },
    onError: ({ message }) => {
      console.log("Error::", message);
    },
  });

  useEffect(() => {
    refetch();
  }, [status]);

  return { tableData, loading, refetch };
};

export default useGetStudentByStatusReport;
